import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { Benchmark } from 'types/Benchmark';
import { JobCreateRecurring, JobCreateImmediate, JobType } from 'types/Job';
import { Job } from 'modules/ManageJobs/ScheduledJobs/types/Job';
import { QueryObserverOptions, useMutation, useQuery } from 'react-query';
import { axiosClient } from './axiosClient';

const resource = '';

const jobs = {
  CreateJob() {
    const [dataEnvironment] = useDataEnvironment();
    return useMutation(
      ['job-post', dataEnvironment?.id],
      (body: JobCreateRecurring | JobCreateImmediate) => {
        return axiosClient.post<Benchmark[]>(
          `${resource}/${dataEnvironment?.id}/jobs`,
          { ...body }
        );
      }
    );
  },
  GetJobs() {
    const [dataEnvironment] = useDataEnvironment();
    return useQuery(['jobs', dataEnvironment?.id], () =>
      axiosClient.get<Job[]>(
        `${resource}/${dataEnvironment?.id}/jobs?jobTypeId=${JobType.Recurring}`
      )
    );
  },
  GetJob(id: number | string | null, option: QueryObserverOptions = {}) {
    const [dataEnvironment] = useDataEnvironment();
    return useQuery(['job', dataEnvironment?.id], () =>
      axiosClient.get<Job>(`${resource}/${dataEnvironment?.id}/jobs/${id}`),
      option
    )
  },
  EditJob() {
    const [dataEnvironment] = useDataEnvironment();
    return useMutation(
      ['jobs-edit', dataEnvironment?.id],
      (props: EditJobProps) =>
        axiosClient.post(
          `${resource}/${dataEnvironment?.id}/jobs/${props.id}/${props.action}`
        )
    );
  },
  DeleteJob() {
    const [dataEnvironment] = useDataEnvironment();
    return useMutation(
      ['jobs-delete', dataEnvironment?.id],
      (id: string) =>
        axiosClient.delete(
          `${resource}/${dataEnvironment?.id}/jobs/${id}`
        )
    );
  },
  UpdateJob(id: string | number | null) {
    const [dataEnvironment] = useDataEnvironment();
    return useMutation(
      ['job-update', dataEnvironment?.id],
      (body: JobCreateRecurring | JobCreateImmediate) => {
        return axiosClient.put<Benchmark[]>(
          `${resource}/${dataEnvironment?.id}/jobs/${id}`,
          { ...body }
        );
      }
    );
  },
};

export interface EditJobProps {
  id: string;
  action: 'disable' | 'enable';
}

export default jobs;
